<script lang="ts">
  import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from "sveltestrap";
  import FeatherIcons from "svelte-feather-icon";
  import { AddTask, Cancel, Description, NewTask, Save, Subtask, TaskTitle } from "../../../utils/Constant/Constant";
  import {tasksManage} from "../../../store"
  let newTaskTitle:string
  let newTaskSubTitle:string
  let open:boolean = false;
  const toggle = (e) => {
    e.preventDefault()
    open = !open
  };
  let setTasksManage:any
  tasksManage.subscribe((value)=>{
    setTasksManage = value
  })
  // for new task add
  const addTasks =(e) => {
    e.preventDefault()
    let newTasks = {
            "title":newTaskTitle,
            "name":"General", 
            "task":newTaskSubTitle
        }
    tasksManage.update(value => value = [...setTasksManage,newTasks])
    newTaskTitle=""
    newTaskSubTitle =""
    open = !open
  }

</script>

<li class="nav-item">
  <Button class="badge-light btn-block btn-mail" on:click={toggle}>
    <FeatherIcons class="me-2" icon="check-circle" />{NewTask}
  </Button>
  <div class="fade modal-bookmark">
    <Modal isOpen={open} {toggle}  class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <ModalHeader {toggle}>
          <h5 class="modal-title">{AddTask}</h5>
        </ModalHeader>
        <ModalBody>
          <Form class="form-bookmark needs-validation" id="bookmark-form" novalidate >
            <Row>
              <FormGroup >
                <Col md="12">
                  <Label for="task-title">{TaskTitle}</Label>
                  <Input id="task-title" type="text" bind:value={newTaskTitle} required autocomplete="off" />
                </Col>
              </FormGroup>
              <FormGroup >
                <Col md="12">
                  <Label for="sub-task">{Subtask}</Label>
                  <Input id="sub-task" type="text" bind:value={newTaskSubTitle} required autocomplete="off"/>
                </Col>
              </FormGroup>
              <Row>
                <FormGroup class="col">
                  <Col>
                    <Label for="Description">{Description}</Label>
                    <Input id="Description" type="text" required autocomplete="off"/>
                  </Col>
                </FormGroup>
              </Row>
            </Row>
            <Button color="secondary" on:click={(e)=>addTasks(e)} >{Save}</Button>
            <Button color="primary" on:click={(e)=>toggle(e)}>{Cancel}</Button>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  </div>
</li>
